module.exports = __webpack_public_path__ + "static/media/Teduglutide in ped patients_12 weeks data_Carter BA, et al. J Pediatrics 2016.9d624cf0.pdf";